export default __webpack_public_path__ + "static/inme_footer-cb5ec778063c0c67c660892993487e3b.svg";